<template>
  <div>
    <Menu_Setting/>
    <Product_Setting/>
  </div>
</template>

<script>
import Menu_Setting from "@/components/admin/setting_product/menu_setting/Menu_Setting.vue";
import Product_Setting from "@/components/admin/setting_product/Product_Setting.vue";
export default {
  name: "ProductSetting",
  components: {
    Product_Setting,
    Menu_Setting
  }
}
</script>

<style scoped>

</style>